/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
// import MKButton from "components/MKButton";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
// import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";
import BachHeader from "bachrosenComponents/bachHeader";

// About Us page sections
import Information from "pages/HomeSite/sections/Information";
import News from "pages/HomeSite/sections/News";
// import Featuring from "pages/LandingPages/AboutUs/sections/Featuring";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/home1.jpg";
// import RenderSocials from "bachrosenComponents/renderSocials";

function HomeSite() {
  return (
    <>
      <DefaultNavbar routes={routes} transparent light center />
      <BachHeader
        image={bgImage}
        title="Bachrose Bietingen"
        description="Mitglied der Narrenvereinigung Hegau Bodensee"
        isWithSocials="true"
      />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Information />
        <News />
        <MKBox component="section" py={12} textAlign="center">
          <MKTypography variant="subtitle1" color="text" verticalAlign="middle">
            Der Brauchtumsverein Bachrose Bietingen e.V. wünscht euch eine glückselige Fasnet!
          </MKTypography>
        </MKBox>
      </Card>
      <MKBox px={1} mt={6}>
        {/* <BachFooter content={footerRoutes} /> */}
        <CenteredFooter content={footerRoutes} />
        {/* <DefaultFooter content={footerRoutes} /> */}
      </MKBox>
    </>
  );
}

export default HomeSite;
